import { makeServer } from './server';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Outlet, RouterProvider } from 'react-router';

import App from './App';
import { routesSection } from './router';
import { ErrorBoundary } from './features/errors/error-boundary';
import { createBrowserRouter } from 'react-router-dom';

globalThis.addEventListener('error', e => {
  if (e.message.includes('ResizeObserver loop')) {
    const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
    const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
    if (resizeObserverErr) resizeObserverErr.setAttribute('style', 'display: none');
    if (resizeObserverErrDiv) resizeObserverErrDiv.setAttribute('style', 'display: none');
  }
});

/**
 * Configure the browser router using Data Router API (v6.4+).
 * We wrap the App component to act as a layout for all child routes,
 * and define a global ErrorBoundary for top-level crashes.
 */
const router = createBrowserRouter([
  {
    Component: () => (
      <App>
        <Outlet />
      </App>
    ),
    errorElement: <ErrorBoundary />,
    children: routesSection,
  },
]);

// Initialize the root element with a non-null assertion for the DOM container.
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(document.getElementById('root')!);

/**
 * Render the application tree:
 * 1. StrictMode: Highlights potential problems during development.
 * 2. RouterProvider: Provides routing context for the entire application.
 */
root.render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);

/**
 * Start the MirageJS mock server to intercept and mock API requests.
 */
makeServer();
